//========== Contact Section Component ==========

import { useRef, useState } from "react";
import { motion, useInView } from "framer-motion";
import { isValidName, isValidEmail, isValidMessage } from "../../utils/formValidation";
import { sendMainEmail, sendConfirmationEmail } from "../../services/emailService";
import "./contact.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const variants = {
  initial: {
    y: 30,
    opacity: 0
  },
  animate: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.5
    }
  }
};
const Contact = () => {
  const ref = useRef();
  const formRef = useRef();
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [success, setSuccess] = useState(false);
  const isInView = useInView(ref, {
    margin: "-100px"
  });
  const clearMessages = () => {
    setTimeout(() => {
      setError(false);
      setErrorMessage('');
      setSuccess(false);
    }, 5000);
  };
  const sendEmail = async e => {
    e.preventDefault();
    const {
      first_name,
      last_name,
      email,
      message
    } = formRef.current;
    if (!isValidName(first_name.value) || !isValidName(last_name.value)) {
      setError(true);
      setErrorMessage('Names must contain only characters.');
      clearMessages();
      return;
    }
    if (!isValidEmail(email.value)) {
      setError(true);
      setErrorMessage('Please enter a valid email address.');
      clearMessages();
      return;
    }
    if (!isValidMessage(message.value)) {
      setError(true);
      setErrorMessage('Message cannot be empty.');
      clearMessages();
      return;
    }
    try {
      const mainEmailResponse = await sendMainEmail(formRef.current);
      console.log("Main Email Sent", mainEmailResponse.text);
      setSuccess(true);
      const confirmationEmailResponse = await sendConfirmationEmail(formRef.current);
      console.log("Confirmation Email Sent", confirmationEmailResponse.text);
      formRef.current.reset();
    } catch (error) {
      console.error("Email Sending Error", error);
      setError(true);
      setErrorMessage('Failed to send email.');
    } finally {
      clearMessages();
    }
  };
  return /*#__PURE__*/_jsxs(motion.div, {
    ref: ref,
    className: "contact",
    id: "connect",
    initial: "initial",
    animate: isInView ? "animate" : "initial",
    variants: {
      initial: {
        opacity: 0,
        y: 50
      },
      animate: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 0.7
        }
      }
    },
    children: [/*#__PURE__*/_jsx(motion.div, {
      className: "textContainer",
      children: /*#__PURE__*/_jsxs(motion.h1, {
        variants: variants,
        children: [/*#__PURE__*/_jsx("span", {
          className: "contactSpan",
          children: "Let\u2019s"
        }), " work together"]
      })
    }), /*#__PURE__*/_jsx("div", {
      className: "formContainer",
      children: /*#__PURE__*/_jsxs(motion.form, {
        ref: formRef,
        onSubmit: sendEmail,
        initial: "initial",
        animate: isInView ? "animate" : "initial",
        variants: {
          initial: {
            opacity: 0
          },
          animate: {
            opacity: 1,
            transition: {
              duration: 0.5,
              delay: 0.5
            }
          }
        },
        children: [/*#__PURE__*/_jsxs("div", {
          className: "name-row",
          children: [/*#__PURE__*/_jsx("input", {
            type: "text",
            required: true,
            placeholder: "First Name",
            name: "first_name",
            autoComplete: "given-name"
          }), /*#__PURE__*/_jsx("input", {
            type: "text",
            required: true,
            placeholder: "Last Name",
            name: "last_name",
            autoComplete: "family-name"
          })]
        }), /*#__PURE__*/_jsx("input", {
          type: "email",
          required: true,
          placeholder: "Your Email",
          name: "email",
          autoComplete: "email"
        }), /*#__PURE__*/_jsx("textarea", {
          rows: "8",
          placeholder: "Message",
          name: "message"
        }), /*#__PURE__*/_jsx("button", {
          type: "submit",
          children: "Submit"
        }), error && /*#__PURE__*/_jsx("div", {
          className: "alert alert-danger",
          children: errorMessage
        }), success && /*#__PURE__*/_jsx("div", {
          className: "alert alert-success",
          children: "Success"
        })]
      })
    })]
  });
};
export default Contact;